import React, { useEffect, useState } from "react";
import { DonutChart } from "@carbon/charts-react";
import axios from "axios";
import ImageLoading from "../../components/ImageLoading";
import { MdOutlineFileDownload } from "react-icons/md";

function NetWorthDonut({ id }) {
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(2)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toString();
  }
  const formatCenterValue = (value) => {
    return `₹${indianNumberFormat(value)}`;
  };

  function formatString(input) {
    return input
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const formatData = (data) => {
    if (data?.length < 1) return [];
    return data?.map((item) => {
      return {
        group: formatString(item.asset_name),
        value: item.value,
      };
    });
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleExcelDownload = async () => {
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/user_portfolio_as_excel`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.response.status) {
        const url = res.data.response.data;

        handleDownloadFile(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fetchNetworthGraph = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/networth_analysis`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data.networth.assets) {
        setGraphData(res.data.networth.assets);
        console.log(res.data);
      } else {
        setNoData(true);
        setGraphData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNoData(true);
    }
  };
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }

  useEffect(() => {
    fetchNetworthGraph();
  }, []);
  const options = {
    title: null,
    toolbar: false,
    tooltip: {
      valueFormatter: (tooltipValue, label) =>
        `${formatToIndianRupees(tooltipValue)}`,
    },
    legend: {
      alignment: "center",
    },

    color: {
      scale: {
        Vehicle: "#26aba4", // Blue
        "Mutual Funds": "#f7a452", // Green
        Stocks: "#66a9e4", // Yellow
        "National Pension Systems": "#6c757d", // Gray
        Bank: "#e8787d", // Red
        "Real Estates": "#9d53f2", // Orange
      },
    },

    resizable: true,

    donut: {
      center: {
        numberFormatter: formatCenterValue,
        label: "Total Net Worth",
      },
      alignment: "center",
    },
    pie: {
      // labels: {
      // formatter: () => void 0,
      //},
    },
    height: "290px",
  };
  return (
    <>
      {loading && (
        <div className="w-full h-full flex items-center justify-center ">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-full flex items-center justify-center ">
          No data found
        </div>
      )}
      {!loading && !noData && (
        <div>
          <div className=" flex justify-between items-center  mt-[17px] mb-[10px]">
            <p className="text-[16px] font-semibold  ml-4   ">Net Worth</p>
            <button
              className=" mr-4  bg-[#00394d] rounded w-6 h-6 flex items-center justify-center"
              onClick={() => {
                handleExcelDownload();
                console.log("Clicked");
              }}
            >
              <MdOutlineFileDownload
                style={{
                  width: 17,
                  height: 17,
                  color: "white",
                }}
              />
            </button>
          </div>
          <div className=" mt-0 ">
            <DonutChart
              data={formatData(graphData)}
              options={options}
            ></DonutChart>
          </div>
        </div>
      )}
    </>
  );
}

export default NetWorthDonut;
